import { motion } from "motion/react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

import { DrawerContentStyled } from "../../drawers/components/drawer";
import { ISystemParamCategoryHeaderColors } from "./parts";

export const SystemParamsDrawerContentStyled = styled(DrawerContentStyled)`
  scrollbar-gutter: stable;

  .system-params__search {
    width: 100%;
    box-sizing: border-box;
    padding-top: 12px;
    margin-bottom: 12px;
    transition:
      filter 0.55s ease-out,
      backdrop-filter 0.55s ease-out;
  }

  &.inner-item-editing-blur .system-params__search {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  .system-params__search-results {
    margin-top: 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }

  .system-params__no-results {
    padding: 12px 24px;
  }
`;

export const SystemParamsTabPanelContentStyled = styled(
  motion.div,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "system-params-tab-panel-content",
})`
  width: 100%;
`;

export const SystemParamsHeaderTitleStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "system-params-header-title",
  },
)`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
`;

export const SystemParamsHeaderTabBadgeStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "system-params-header-tab-badge",
  },
)<{ $colors: ISystemParamCategoryHeaderColors }>`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
  padding: 2px 10px;
  border: none;
  border-radius: 999px;
  background-color: ${({ $colors }) => $colors.backgroundColor};
  box-shadow: ${({ $colors }) => $colors.boxShadow};
  color: ${({ $colors }) => $colors.color};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition:
    background-color 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    color 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.28s cubic-bezier(0.22, 1, 0.36, 1);

  @media (prefers-reduced-motion: reduce) {
    transition:
      background-color 0.15s ease,
      color 0.15s ease,
      box-shadow 0.15s ease;
  }
`;
